import { render, staticRenderFns } from "./MobileLiveMain.vue?vue&type=template&id=9653f9e8&scoped=true"
import script from "./MobileLiveMain.vue?vue&type=script&lang=js"
export * from "./MobileLiveMain.vue?vue&type=script&lang=js"
import style0 from "./MobileLiveMain.vue?vue&type=style&index=0&id=9653f9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9653f9e8",
  null
  
)

export default component.exports